import { useState, type FormEvent } from "react";
import { ApiError, auth } from "../api/client";
import { t } from "../i18n/en";

export default function Login({ onSignedIn }: { onSignedIn: (username: string) => void }) {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  async function submit(event: FormEvent) {
    event.preventDefault();
    setBusy(true);
    setError("");
    try {
      const user = await auth.login(username, password);
      onSignedIn(user.username);
    } catch (err) {
      // Distinguishing these matters: "wrong password" is the user's problem, "can't reach the
      // server" is mine, and showing the first when it's the second sends people hunting for a
      // password that was fine all along.
      setError(err instanceof ApiError && err.status === 0 ? t.login.unreachable : t.login.failed);
      setBusy(false);
    }
  }

  return (
    <div className="screen centered">
      <div className="card">
        <div className="brand">
          <h1>{t.appName}</h1>
          <p>{t.tagline}</p>
        </div>
        <form onSubmit={submit}>
          <label htmlFor="username">{t.login.username}</label>
          <input
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoCapitalize="none"
            autoCorrect="off"
            autoComplete="username"
            required
          />
          <label htmlFor="password">{t.login.password}</label>
          <input
            id="password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="current-password"
            required
          />
          <p className="error">{error}</p>
          <button type="submit" disabled={busy}>
            {busy ? t.login.submitting : t.login.submit}
          </button>
        </form>
      </div>
    </div>
  );
}
